import { DragOverlay } from "@dnd-kit/core";

import { DRAGGABLE_TYPES } from "./constants";

const DndOverlay = ({ props, state }) => {
  const { renderSectionOverlay, renderItemOverlay } = props;
  const data = state.active?.data.current || {};

  return (
    <DragOverlay className="neeto-ui-shadow-xs">
      {data.type === DRAGGABLE_TYPES.ITEM && renderItemOverlay?.(data)}
      {data.type === DRAGGABLE_TYPES.SECTION && renderSectionOverlay?.(data)}
    </DragOverlay>
  );
};

export default DndOverlay;
